import FolderIcon from "@assets/icons/folderIcon";
import Button from "@components/Button";
import ClickOutside from "@components/ClickOutside";
import { IExportingArtboardNames } from "@routes/private/Editor/types";
import React, { useEffect } from "react";
import * as S from "./styles";
import * as T from "./types";

const AssetsNames: React.FC<T.IProps> = (props) => {
  const[names, setNames] =  React.useState<IExportingArtboardNames[]>();

  const handleChange = (newname:string, index:number)=>{

    if (names){    
       let newExportingNames  = names.map((n,i)=>{          
          return {
            id: n.id,
            name: n.name,
            savename: (i==index)?newname +"."+props.format.toLocaleLowerCase():n.savename,                        
            url:n.url,
            overwrite:(i==index)?(n.name==newname?true:false):n.overwrite,
            changed: (i==index)?(n.name==newname?false:true):n.changed,
          }          
        });
        setNames(newExportingNames);        
        props.changeNames(newExportingNames);       
    }   
    
    
  }
  
  const handleOverwrite = (index:number)=>
  {
    if (names){    
      let newExportingNames  = names.map((n,i)=>{
         return {
           id: n.id,
           name: n.name,
           savename: (i==index)?n.name:n.savename,            
           url:n.url,
           overwrite: (i==index)?true: n.overwrite,
           changed: (i==index)?false: n.changed,
         }          
       });
       setNames(newExportingNames);       
       //props.names = newExportingNames
        props.changeNames(newExportingNames);       
   }   
    
  }


  React.useEffect(() => {
    if (props.names)
    {
      setNames(props.names);
    }
  }, [props.names]);


  return (
    <S.Root>
      <ClickOutside
        onClickOutside={()=>{}}
        event="mousedown"
      >
        <S.ExplorerContainer>
          {
            names && names.map((name, index) => {
              if (name.url!="")
              {
                return(
                  <S.ItemContainer>
                  <S.AssetImage src={name.url}></S.AssetImage>
                  <S.AssetInputName value={name.savename.replace("."+props.format.toLocaleLowerCase(),"")} onChange={(event:any)=>handleChange(event.target.value,index)}></S.AssetInputName>                                    
                  {
                    name.savename !== name.name &&
                  <S.AssetOverwrite onClick={()=>handleOverwrite(index)}>REPLACE EXISTING</S.AssetOverwrite>
                  }

                  </S.ItemContainer>

                )

              }
              
            })
          }
         
        </S.ExplorerContainer>
       
      </ClickOutside>
    </S.Root>
  );
}

export default AssetsNames;